<template>
	<vue-editor
		:id="id"
		:placeholder="placeholder"
		:disabled="disabled"
		v-model="content"
	></vue-editor>
</template>

<script>
	// External WYSIWYG component
	import { VueEditor } from 'vue2-editor'

	export default {
		name: 'text-editor',

		props: {
			/**
			 * Id para deixar o text-editor único
			 */
			id: {
				type: String,
				default: 'text-editor'
			},
			/**
			 * Captura o valor do v-model externo e o joga para o content data interno
			 */
			value: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Placeholder para o text-editor
			 */
			placeholder: {
				type: String,
				default: 'Digite aqui o conteúdo...'
			},
			/**
			 * Ele está desabilitado?
			 */
			disabled: {
				type: Boolean,
				default: false
			}
		},

		components: { VueEditor },

		data() {
			return {
				content: ''
			}
		},

		mounted() {
			this.content = this.value
		},

		watch: {
			content(text) {
				this.$emit('input', text)
			},

			value(text) {
				this.content = text
			}
		}
	}
</script>

<style lang="stylus">
	@import './styles.styl'
</style>
